import React from 'react';

import styled, { keyframes } from 'styled-components';

const scale = keyframes`
  0% { transform: scale(1) translate(-40%, -40%); }
  100% { transform: scale(1.4) translate(-40%, -40%); }
`;
const rotate360 = keyframes`
  0% { transform: rotate(0deg); }
  50% { transform: rotate(180deg); }
  100% { transform: rotate(360deg); }
`;
const MarkerGroup = styled.div`
  display: flex;
  position: absolute;
  justify-content: center;
  align-items: center;
  width: 60px;
  height: 60px;
  text-align: center;
  cursor: pointer;
  z-index: 1;
  transform: translate(-40%, -40%);
  transform-origin: 10% 10%;

  &:hover, &.active {
    animation: ${scale} .25s linear forwards;
  }
  &:hover .icon, &.active .icon {
    animation: ${rotate360} 2s linear infinite;
  }
`;
const ClusterMarker = styled.div`
  position: absolute;
  width: 60px;
  height: 60px;
  z-index: 1;
`;
const MarkerCounter = styled.div`
  position: relative;
  font-size: 14px;
  color: #474747;
  z-index: 2;
  cursor: pointer;
`;

const cluster = (props) => {
  const { tab, totalGood, goodGrade, nsGrade, poorNowcast, points, numAlerts, numNowcast } = props;
  let goodStrokeDash, nsStrokeDash, goodDashOffset, numClusters, nsDashOffset = 92;
  
  switch (tab) {
    default:
    case 0:
      nsStrokeDash = nsGrade + ' ' + (100 - nsGrade);
      goodStrokeDash = totalGood + ' ' + (100 - totalGood);
      goodDashOffset = 100 - nsGrade + nsDashOffset;
      numClusters = points.length;
      break;
    case 1:
      nsStrokeDash = 0 + ' ' + 100;
      goodStrokeDash = (100 - poorNowcast)  + ' ' + poorNowcast;
      goodDashOffset = 100 + nsDashOffset;
      numClusters = numNowcast;
      break;
    case 2:
      nsStrokeDash = nsGrade + ' ' + (100 - nsGrade);
      goodStrokeDash = goodGrade + ' ' + (100 - goodGrade);
      goodDashOffset = 100 - nsGrade + nsDashOffset;
      numClusters = points.length;
      break;
    case 3:
      nsStrokeDash = '0 100';//'20 80'
      goodStrokeDash = '0 100';
      goodDashOffset = 0;
      numClusters = numAlerts;
      break;
  }

  return (
    <MarkerGroup className={props.isActive ? 'active' : ''}>
      <ClusterMarker className="icon">
        <svg width="100%" height="100%" viewBox="0 0 42 42">
          <circle className="donut-hole" cx="21" cy="21" r="15.91549430918954" fill="#fff" shapeRendering="optimizeQuality"></circle>
          <circle className="donut-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#F26859" strokeWidth="3" shapeRendering="optimizeQuality"></circle>
          <circle className="donut-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#B3B3B3" strokeWidth="3" shapeRendering="optimizeQuality"
            strokeDasharray={nsStrokeDash} strokeDashoffset={nsDashOffset}></circle>
          <circle className="donut-segment" cx="21" cy="21" r="15.91549430918954" fill="transparent" stroke="#0066FF" strokeWidth="3" shapeRendering="optimizeQuality" 
            strokeDasharray={goodStrokeDash} strokeDashoffset={goodDashOffset}></circle>
        </svg>
      </ClusterMarker>
      <MarkerCounter className="count">
        {numClusters}
      </MarkerCounter>
    </MarkerGroup>
  );
}


export default cluster;



// WEBPACK FOOTER //
// ./src/components/Marker/Cluster.js